// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

export const CURRENT_PAGE_CHANGE = 'CURRENT_PAGE_CHANGE';
export const RESTORE_STATUS_CHANGE = 'RESTORE_STATUS_CHANGE';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_TOKEN_VALIDATION_ERROR = 'SET_TOKEN_VALIDATION_ERROR';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const LANGUAGE_CHANGED = 'LANGUAGE_CHANGED';
